import { createApiSaga } from '../../../sagaGenerator';
import { apiGet } from '../../../../middleware/api';
import {
  GET_RUNUP_INFO_REQUEST,
  GET_RUNUP_INFO_SUCCESS,
  GET_RUNUP_INFO_FAILURE,
  GET_RUNUP_INFO_REFERENCES_REQUEST,
  GET_RUNUP_INFO_REFERENCES_SUCCESS,
  GET_RUNUP_INFO_REFERENCES_FAILURE,
} from './runupInfoReducer';

const getRunupInfoSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/runups/${action.id}/info`, ...action }),
  requestType: GET_RUNUP_INFO_REQUEST,
  successType: GET_RUNUP_INFO_SUCCESS,
  failureType: GET_RUNUP_INFO_FAILURE,
});

const getRunupReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/runups/${action.id}/references`, ...action }),
  requestType: GET_RUNUP_INFO_REFERENCES_REQUEST,
  successType: GET_RUNUP_INFO_REFERENCES_SUCCESS,
  failureType: GET_RUNUP_INFO_REFERENCES_FAILURE,
});

export const runupInfoSagas = [
  getRunupInfoSaga,
  getRunupReferencesSaga,
];
